import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransportDriverApi } from './transporterDrivers';


export interface TransporterDriverInterface {
    id: string;
    name: string;
    address: {
        street: string;
        city: string;
        country: string;
    };
    phone: string;
}

const initialState: TransporterDriverInterface = {
    id: '',
    name: '',
    address: {
        street: '',
        city: '',
        country: '',
    },
    phone: '',
};

export const TransporterDriverSlice = createSlice({
    name: 'TransporterDriver',
    initialState,
    reducers: {
        saveTransporterDriver: (
            state: TransporterDriverInterface,
            action: PayloadAction<TransporterDriverInterface>
        ) => {
            return { ...state, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                TransportDriverApi.endpoints.getDriverList.matchFulfilled,
                (
                    state: TransporterDriverInterface,
                    action: PayloadAction<TransporterDriverInterface>
                ) => {
                    return { ...state, ...action.payload };
                }
            )
            .addMatcher(
                TransportDriverApi.endpoints.patchTransporterDriverById.matchFulfilled,
                (
                    state: TransporterDriverInterface,
                    action: PayloadAction<TransporterDriverInterface>
                ) => {
                    return { ...state, ...action.payload };
                }
            );
    },
});

export const { saveTransporterDriver } = TransporterDriverSlice.actions;

export default TransporterDriverSlice.reducer;
